module.exports = __webpack_public_path__ + "media/images/site/CTERCEIRAO_VANTAGENS-e2d3831521802ae3fcd9a8aabfec1f29.jpg";